export const CUSTOM = "custom";
export const COLLECTION = "collection";
export const POPCLIPS = "popclips";